import autoPayments from './autoPayments'
import paymentMethods from './paymentMethods'
import payments from './payments'
import repaymentPlans from './repaymentPlans'
import repayments from './repayments'
import refundMethod from './refundMethod'
import paymentSummary from './paymentSummary'
import autoPaymentSummary from './autoPaymentSummary'
import moneygram from './moneygram'

export default {
  autoPayments,
  paymentMethods,
  payments,
  repaymentPlans,
  repayments,
  refundMethod,
  paymentSummary,
  autoPaymentSummary,
  moneygram,
}
